import { styles as stylesFn } from '@/common/style';
import { ThemeColorMap } from '@/hooks/abTest/useCouponPush';
import React, { memo, useState } from 'react';
import { View, Text } from 'react-native';
import { useCountDown } from 'ahooks';
import { withZeroText } from '@/common/utils/withZeroText';

const detailInfoCol = {
    leftCircle: stylesFn({
        width: 6,
        height: 6,
        borderRadius: 4,
        borderWidth: 1,
        left: -4,
        top: 5,
        backgroundColor: '#fff',
        position: 'absolute',
    }),
    leftCircleMask: stylesFn({
        position: 'absolute',
        top: 5,
        left: -6,
        height: 8,
        width: 4,
        backgroundColor: '#fff',
        zIndex: 2,
    }),
    rightCircle: stylesFn({
        width: 6,
        height: 6,
        borderRadius: 4,
        borderWidth: 1,
        right: -4,
        top: 5,
        backgroundColor: '#fff',
        position: 'absolute',
    }),
    rightCircleMask: stylesFn({
        position: 'absolute',
        top: 5,
        right: -5,
        height: 8,
        width: 4,
        backgroundColor: '#fff',
        zIndex: 2,
    }),
    tagItemView: stylesFn({
        backgroundColor: 'rgba(255, 73, 6, 0.12)',
        borderRadius: 3,
        borderWidth: 1,
        fontSize: 11,
        height: 18,
        color: '#FF4906',
        paddingHorizontal: 4,
        position: 'relative',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
    }),
    tagText: stylesFn({
        fontSize: 11,
        lineHeight: 16,
    }),
};

// 商品「商家包邮」券标样式

interface IProps {
    text: string;
    type: '2' | '3' | 2 | 3 | 'product' | 'shipping';
    countDown?: number;
    isOrderConfirm?: boolean;
    initPageData?: () => void;
}

function CountDownText({ leftTime, targetDate = 0, onEnd }: { targetDate?: number; leftTime: number; onEnd?: () => void }) {
    const [_, formateTime] = useCountDown({
        leftTime: Math.round(leftTime / 1000) * 1000,
        interval: 1000,
        targetDate,
        onEnd,
    });
    const timeText = `${withZeroText(formateTime.hours)}:${withZeroText(formateTime.minutes)}:${withZeroText(formateTime.seconds)}`;
    return <>{timeText}</>;
}

const Coupon = (props: IProps) => {
    const { text, type, countDown = 0, isOrderConfirm = false, initPageData } = props;
    const typeMap = {
        2: 'product',
        3: 'shipping',
    };
    const _type = Object.prototype.hasOwnProperty.call(typeMap, type) ? typeMap[type] : type;
    const themeColor = ThemeColorMap[_type];

    const [countDownVisible, setCountDownVisible] = useState(true);
    return (
        <View style={{ overflow: 'hidden' }}>
            <View style={[detailInfoCol.tagItemView, { borderColor: themeColor.border, backgroundColor: themeColor.background }]}>
                <View style={[detailInfoCol.leftCircle, { borderColor: themeColor.border }]} />
                <View style={[detailInfoCol.leftCircleMask, { borderColor: themeColor.border }]} />
                <Text numberOfLines={1} style={[detailInfoCol.tagText, { color: themeColor.text }]}>
                    {text}
                    {countDown < 3600000 && countDown > 0 && isOrderConfirm && countDownVisible ? (
                        <>
                            &nbsp;
                            <CountDownText
                                leftTime={countDown}
                                onEnd={() => {
                                    initPageData();
                                    setCountDownVisible(false);
                                }}
                            />
                        </>
                    ) : null}
                </Text>
                <View style={[detailInfoCol.rightCircle, { borderColor: themeColor.border }]} />
                <View style={[detailInfoCol.rightCircleMask, { borderColor: themeColor.border }]} />
            </View>
        </View>
    );
};
export const CouponSmallest = memo(Coupon);
